module.exports = __webpack_public_path__ + "static/img/kefu.0d5b7203.png";